import axios from 'axios';

export const axiosIntance = axios.create({
    baseURL : "https://lts-mahal-h2arcjesezf0b9cu.canadacentral-01.azurewebsites.net/api/v1",
    headers: {
    'X-API-Key': 'lkebxhdxysgyfpkh',
    
  }
  
})